import { css } from '@microsoft/fast-element';
import { scrollbarStyles } from '../../../../styles';

export const MyProjectsContainerStyles = css`
  ${scrollbarStyles}
  .container {
    width: 100%;
  }

  .container zero-tabs.top-level::part(tablist) {
    background: transparent;
  }

  .container .top-level zero-tab[aria-selected='true'] {
    color: var(--primary-color);
    border-bottom: 1px solid var(--primary-color);
  }

  .container .top-level zero-tab[aria-selected='false']:hover {
    color: #fff;
  }

  .container .top-level zero-tab {
    width: 50%;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    font-size: 13px;
    color: var(--top-level-tab-font);
  }

  zero-tabs::part(tabpanel) {
    height: calc(100vh - 200px);
    overflow: auto;
    display: block;
  }

  .container-header {
    height: 44px;
    border-bottom: 1px solid var(--border-1);
    margin-bottom: 8px;
    display: flex;
  }

  .container-buttons {
    margin-left: auto;
    margin-right: 8px;
    margin-top: 6px;
    display: flex;
  }

  .container-title {
    margin: 0;
    font-size: 16px;
    white-space: nowrap;
    padding: 4px 16px 4px 16px;
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-weight: 700;
    color: var(--white-rgb);
    text-align: left;
    line-height: 40px;
  }

  .project-list {
    display: flex;
    flex-direction: column;
  }

  .draft-project-list {
    display: flex;
    gap: 9px;
    flex-direction: column;
    padding-top: 12px;
  }

  .my-projects-padding {
    padding-left: 15px;
    padding-right: 14px;
  }

  .no-project-listed {
    display: flex;
    justify-content: center; /* Center content horizontally */
    align-items: center; /* Center content vertically */
    height: 100%; /* Adjust as necessary */
    margin-top: 50px;
  }
`;
